<template>
  <!--Range-->
  <div class="input-group input-daterange" v-if="range">
    <input
      type="text"
      autocomplete="off"
      data-datepicker
      class="form-control"
      :placeholder="'Başlangıç'|trans"
      name="start"
      :value="value ? value.start : null"
    />
    <input
      type="text"
      autocomplete="off"
      data-datepicker
      class="form-control"
      :placeholder="'Bitiş'|trans"
      name="end"
      :value="value ? value.end : null "
    />
  </div>

  <!--Single-->
  <input
    v-else
    type="text"
    data-datepicker
    class="form-control mb-2"
    :value="value"
    :placeholder="placeholder || 'Tarih seçiniz' | trans"
  >
</template>

<script>
  export default {
    props: ["range", "value", "placeholder"],
    data() {
      return {
        start: null,
        end: null
      }
    },
    mounted() {
      let vm = this;

      vm.$nextTick(() => {

        $(vm.$el)
          .datepicker({
            format: 'dd.mm.yyyy',
            language: "tr",
            autoclose: true,
            todayBtn: 'linked',
            clearBtn: true,
            todayHighlight: false,
            endDate: new Date()
          })
          .on("changeDate", function (e) {
            if (vm.range) {
              vm.$emit("input", vm.setDate(e.target.name, e.date));
            } else {
              vm.$emit("input", e.date ? e.date.toLocaleDateString('tr-TR') : null);
            }
          });
      })
    },
    methods: {
      setDate(type, date) {
        let dates = {};

        if (this.value) {
          if (this.value.start) {
            dates.start = this.value.start;
          }
          if (this.value.end) {
            dates.end = this.value.end;
          }
        }

        if (date) {
          dates[type] = date.toLocaleDateString('tr-TR');
        } else {
          delete dates[type];
        }

        return dates;
      }
    },
    watch: {
      value: function (newVal, oldVal) {
        if (newVal && newVal.hasOwnProperty('start') && newVal.hasOwnProperty('end')) {
          if (Date.parse(newVal.end) < Date.parse(newVal.start)) {
            newVal.end = newVal.start;

            this.$buefy.dialog.alert({
              title: this.trans('Hata'),
              message: this.trans('Bitiş tarihi Başlangıç tarihinden küçük olamaz!'),
              type: 'is-danger',
              hasIcon: true,
              icon: 'times-circle',
              iconPack: 'fa',
              ariaRole: 'alertdialog',
              ariaModal: false
            })
          }
        }
      }
    },
    destroyed: function () {
      $(this.$el).off().datepicker("destroy");
    }
  }
</script>
